import AXIOS_INTERCEPTORS from "./api-plagin.js";
import SourceRepository from "./SourceRepository.js";

export default {
    install: (app) => {
        const axios_intercepted = new AXIOS_INTERCEPTORS(app.config.globalProperties.$store, app.config.globalProperties.$router);
        const api = axios_intercepted.create()
        app.config.globalProperties.$API = {
            request: api,
            manager: new SourceRepository(api),
        };
    },
};
